<template>
  <div class="filter-form">
    <div class="search-row">
      <v-text-field
        v-model="form.q"
        class="search-field"
        density="comfortable"
        variant="solo"
        rounded="pill"
        flat
        hide-details
        clearable
        placeholder="Найти товар…"
        prepend-inner-icon="mdi-magnify"
        @keydown.enter="emitNow"
      />
      <v-btn
        class="filter-toggle"
        icon
        flat
        :color="hasCharacteristic || filtersOpen ? 'primary' : 'surface'"
        @click="filtersOpen = !filtersOpen"
      >
        <v-icon>mdi-tune-variant</v-icon>
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-show="filtersOpen" class="pt-2">
        <v-text-field
          v-model="form.characteristic"
          density="comfortable"
          variant="solo"
          rounded="lg"
          flat
          hide-details
          clearable
          placeholder="Размер, например 42"
          prepend-inner-icon="mdi-ruler"
          @keydown.enter="emitNow"
        />
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'FormFilter',
  data() {
    return {
      form: { q: '', characteristic: '' },
      filtersOpen: false,
      debounceTimer: null,
    };
  },
  computed: {
    hasCharacteristic() {
      return !!this.form.characteristic;
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(this.emitNow, 300);
      },
    },
  },
  beforeUnmount() {
    clearTimeout(this.debounceTimer);
  },
  methods: {
    emitNow() {
      clearTimeout(this.debounceTimer);
      const params = {};
      if (this.form.q) params.q = this.form.q;
      if (this.form.characteristic)
        params.characteristic = this.form.characteristic;
      this.$emit('updateForm', params);
    },
  },
};
</script>

<style scoped>
.search-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-field :deep(.v-field) {
  box-shadow: 0 2px 12px rgba(28, 33, 48, 0.08);
}

.filter-toggle {
  box-shadow: 0 2px 12px rgba(28, 33, 48, 0.08);
}
</style>
